import React, { useEffect, useState } from "react";
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { useDispatch, useSelector } from "react-redux";
import { getAllStation } from "../../slices/stations/thunk";
import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { staionsColumnData } from "./constants/ColumnsForStationTable";
import { Loader } from "../Utils/Loader";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { toggleAccordion } from "../Customers/constants/constantFunctions";
import Preview from "./Preview";
import {
  setEditSuccessMessage,
  setSuccessMessage,
} from "../../slices/toastMessage/action";
import { ToastContainer, toast } from "react-toastify";
import { setDefault, storeRow } from "../Utils/SetDefaultRowData";
import { PAGE_TITLES } from "../Common/constants";
import { useColumnSettings } from "../Utils/useColumnSettings";
import { getView } from "../../slices/View/thunk";
import { hasPermission } from "../Utils/UtilityFunctions";
import CommonModal from "../Utils/CommonModal";
import { editStation } from "../../slices/stations/editstation/thunk";

function StationListings() {
  const [open, setOpen] = useState("1");
  const [index, setIndex] = useState(null);

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const showSuccessMessage = useSelector(
    (state) => state.SuccessToast.showSuccessMessage
  );
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [data, setData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const [stationDetails, setStationDetails] = useState(null);

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    // document.body.style.overflow = 'auto'
  };

  const StationName = [];
  const StationAddress = [];
  const evse = [];
  const connector = [];
  const toggle = toggleAccordion(open, setOpen);

  useEffect(() => {
    dispatch(getAllStation(setLoading));
    dispatch(getView(setLoading));
  }, [dispatch]);

  const stationData = useSelector((state) => state.Stations.station);
  const showEditSuccessMessage = useSelector(
    (state) => state.SuccessToast.showEditSuccessMessage
  );
  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const stationPermission = hasPermission(permissionsMap, "station", "station");
  const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view");

  // useEffect(() => {
  //   const filteredData = stationData?.filter((row) => {
  //     const globalFilterLower = globalFilter?.toLowerCase().trim();
  //     if (!globalFilterLower) return true;
  //     const searchTerms = globalFilterLower.split(" ");
  //     return searchTerms.every(
  //       (term) =>
  //         (row?.stationDetails?.stationID &&
  //           row?.stationDetails?.stationID.toLowerCase().includes(term)) ||
  //         (row?.stationDetails?.name &&
  //           row?.stationDetails?.name.toLowerCase().includes(term)) ||
  //         (row?.stationDetails?.address &&
  //           row?.stationDetails?.address.toLowerCase().includes(term)) ||
  //         (row?.stationDetails?.status &&
  //           row?.stationDetails?.status.toLowerCase() === term) ||
  //         (row?.stationDetails?.adminStatus &&
  //           row?.stationDetails?.adminStatus.toLowerCase() === term)
  //     );
  //   });
  //   setData(filteredData);
  // }, [globalFilter, stationData]);

  useEffect(() => {
    if (Array.isArray(stationData)) {
      setStations(stationData);
    }
  }, [stationData]);

  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
  });

  const stationDetailsArray = stations.map((station) => station.stationDetails);

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(stationDetailsArray);
    download(csvConfig)(csv);
  };

  let columns = staionsColumnData(evse, connector, StationName, StationAddress);

  stations.forEach((station, index) => {
    StationName[index] = station?.stationDetails.name || "-";
    StationAddress[index] = station?.stationDetails.address || "-";
    if ("evse" in station?.stationDetails) {
      let evseCount = 0;
      let connectorCount = 0;
      station.stationDetails.evse.forEach((evseDetails) => {
        evseCount += evseDetails.evseid;
        connectorCount += evseDetails.connectors.length;
      });
      evse[index] = evseCount;
      connector[index] = connectorCount;
    } else {
      evse[index] = 0;
      connector[index] = 0;
    }
  });

  const onSubmit = (values) => {
    const jsonObj = JSON.stringify({
      stationID: values.stationID,
      name: values.name,
      serialNumber: values.serialNumber,
      model: values.model,
      address: values.address,
      vendorName: values.vendorName,
      firmwareVersion: values.firmwareVersion,
      modem: {
        iccid: values.modem.iccid,
        imsi: values.modem.imsi,
      },
      timeZone: values.timeZone,
      coordinates: {
        latitude: parseFloat(values?.coordinates?.latitude),
        longitude: parseFloat(values?.coordinates?.longitude),
      },
      adminStatus: actionType,
      OCPPVersion: values.OCPPVersion,
    });
    dispatch(
      editStation(
        jsonObj,
        { stationDetails: { stationID: values.stationID } },
        setLoading,
        navigate,
        () => {
          dispatch(getAllStation(setLoading));
        }
      )
    );
  };

  const navigateToStation = async (id) => {
    let path = `/station/${id.original.stationDetails.stationID}`;
    navigate(path, { state: { stationDetails: id.original.stationDetails } });
  };

  const navigateToViewStation = async (id) => {
    let path = `/view-station/${id.original.stationDetails.stationID}`;
    navigate(path, { state: { stationDetails: id.original.stationDetails } });
  };

  const navigateToCreateStation = async (id) => {
    let path = `/create-station`;
    navigate(path);
  };
  useEffect(() => {
    if (showSuccessMessage) {
      toast.success(`Station Updated Successfully`);
      dispatch(setSuccessMessage(false));
    }
    if (showEditSuccessMessage) {
      toast.success(`Station Created Successfully`);
      dispatch(setEditSuccessMessage(false));
    }
  }, [showSuccessMessage, dispatch]);

  const {
    settingsModalOpen,
    viewColumns,
    toggleSettingsModal,
    SettingsSidebar,
    CustomViewModal,
  } = useColumnSettings("station", columns);

  return (
    <React.Fragment>
      <div id="csms" className="page-content">
        <Container fluid>
          <BreadCrumb
            title={PAGE_TITLES.STATION_LIST}
            pageTitle={PAGE_TITLES.STATION}
          />
          <ToastContainer position="top-center" />
          <Row>
            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
              <div className="d-flex flex-column flex-md-row">
                <h5 className="rv-page-title p-1">{"Station Listing"}</h5>
              </div>
              <div className="d-flex align-items-center">
                {stationPermission && stationPermission?.has("export") && (
                  <Button
                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap mx-1"
                    onClick={handleExportData}
                  >
                    <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2 fw-bold"></i>
                    <span className="px-2 ps-3 ms-2 me-1 fw-bold">Export</span>
                  </Button>
                )}
                {stationPermission && stationPermission?.has("create") ? (
                  <Button
                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap mx-1"
                    onClick={navigateToCreateStation}
                  >
                    <i className="ri-add-fill label-icon align-middle fs-16 me-1 fw-bold"></i>
                    <span className="ps-2 ms-2 me-1 fw-bold">
                      {"Add Station"}
                    </span>
                  </Button>
                ) : null}
                {viewPermission && viewPermission?.has("view") && (
                  <div
                    color="secondary"
                    className="btn-icon cursor-img"
                    onClick={toggleSettingsModal}
                  >
                    <i className="ri-settings-2-line fs-4"></i>
                  </div>
                )}
                <i
                  className="ri-refresh-line p-2 fw-bolder ms-2"
                  style={{ fontSize: "20px", cursor: "pointer" }}
                  onClick={() => dispatch(getAllStation(setLoading))}
                  title="Refresh"
                ></i>
              </div>
            </div>
            <Col lg={12}>
              <div className="mb-3 mt-1 mx-1 border table-responsive">
                {loading && <Loader />}
                {stations ? (
                  <MaterialReactTable
                    muiTableDetailPanelProps={{
                      sx: {
                        fontFamily: "Inter,sans-serif",
                      },
                    }}
                    displayColumnDefOptions={{
                      "mrt-row-actions": {
                        header: "",
                        enableHiding: true,
                        size: 52,
                        grow: true,
                      },
                    }}
                    defaultColumn={{
                      minSize: 10,
                      maxSize: 9001,
                      muiTableBodyCellProps: {
                        sx: {
                          fontFamily: "Inter,sans-serif",
                        },
                      },
                      muiTableHeadCellProps: {
                        sx: {
                          fontFamily: "Inter,sans-serif",
                        },
                      },
                    }}
                    columns={columns.filter((column) =>
                      viewColumns?.includes(column.accessorKey || column.header)
                    )}
                    data={stations}
                    enableGlobalFilter={true} 
                    enableColumnOrdering={false}
                    enableColumnDragging={false}
                    enableRowActions
                    enableDensityToggle={false}
                    enableColumnActions={true}
                    enableTopToolbar={false}
                    initialState={{
                      columnVisibility: {
                        "mrt-row-expand": false,
                        "stationDetails.stationID": false,
                      },
                    }}
                    renderRowActionMenuItems={({ closeMenu, row }) => [
                      stationPermission && stationPermission?.has("view") ? (
                        <MenuItem
                          className="row-options"
                          key="view"
                          onClick={() => {
                            navigateToViewStation(row);
                          }}
                        >
                          <i className="ri-eye-line me-2" />
                          View
                        </MenuItem>
                      ) : null,
                      stationPermission && stationPermission?.has("update") ? (
                        <MenuItem
                          className="row-options"
                          key="edit"
                          onClick={() => {
                            navigateToStation(row);
                          }}
                        >
                          <i className="bx bxs-edit me-2" />
                          Edit
                        </MenuItem>
                      ) : null,
                      // stationPermission && stationPermission?.has("update") ? (
                      //   <MenuItem
                      //     className="row-options"
                      //     key="deactivate"
                      //     onClick={() => {
                      //       setActionType(
                      //         row.original.stationDetails.adminStatus ===
                      //           "Deactivate" ||
                      //           row.original.stationDetails.adminStatus ===
                      //             "Inactive"
                      //           ? "Active"
                      //           : "Inactive"
                      //       );
                      //       setStationDetails(row.original.stationDetails);
                      //       toggleModal();
                      //       closeMenu();
                      //     }}
                      //   >
                      //     <i className="bx bxs-edit me-2" />
                      //     {row.original.stationDetails.adminStatus ===
                      //       "Deactivate" ||
                      //     row.original.stationDetails.adminStatus === "Inactive"
                      //       ? "Activate"
                      //       : "Deactivate"}
                      //   </MenuItem>
                      // ) : null,
                    ]}
                    // manualFiltering
                    // onGlobalFilterChange={setGlobalFilter}
                    // state={{ globalFilter }}
                    renderDetailPanel={({ row }) => (
                      <Preview
                        row={row}
                        activeTab={activeTab}
                        tabChange={tabChange}
                      />
                    )}
                  />
                ) : null}
              </div>
            </Col>
            {CustomViewModal()}
          </Row>
          <CommonModal
            modalHeader={`${
              (actionType === "Deactivate" || actionType === "Inactive") ? "Deactivate" : "Activate"
            } Station`}
            open={modalOpen}
            toggle={toggleModal}
            buttonText={(actionType === "Deactivate" || actionType === "Inactive") ? "Deactivate" : "Activate"}
            closeButtonText="Close"
            messageForPopUp={`Are you sure you want to ${
              (actionType === "Deactivate" || actionType === "Inactive") ? "deactivate" : "activate"
            } the station?`}
            modalAction={() => {
              onSubmit(stationDetails);
              toggleModal();
            }}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}

export default StationListings;
